import { defineStore } from "pinia";

interface User {
  email: string;
  email_verified: boolean;
  hd: string;
  family_name: string;
  given_name: string;
  name: string;
  picture: string;
  id: string;
  iat: number;
  exp: number;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isLoggedIn: boolean;
}

export const useAuthStore = defineStore("auth", {
  state: (): AuthState => ({
    user: null,
    token: null,
    isLoggedIn: false,
  }),

  getters: {
    getUser: (state) => state.user,
    isAuthenticated: (state) => state.isLoggedIn && !!state.token,
  },

  actions: {
    setUser(user: User) {
      this.user = user;
      this.isLoggedIn = !!user;
    },

    setToken(token: string) {
      this.token = token;
    },

    logout() {
      this.user = null;
      this.token = null;
      this.isLoggedIn = false;
      window.location.reload();
    },
  },
});
